<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
  >
    <component
      :is="computeCurrentView"
      @setView="setView"
      @showDebitedAmount="showDebitedAmountFlow"
      @closeDialog="handleClose"
    />
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'PendingAssetTransfer',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'confirm-pending-transfer'
    }
  },
  components: {
    PendingTransfer: () =>
      import('@/components/terminal/terminalSkeleton/PendingTransfer.vue'),
    ConfirmPendingTransfer: () =>
      import(
        '@/components/terminal/terminalSkeleton/ConfirmPendingTransfer.vue'
      )
  },
  data () {
    return {
      currentView: this.view
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '27%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    computeCurrentView () {
      return this.currentView
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    setView (view) {
      this.currentView = view
    },
    next () {
      this.$emit('showMakePayment')
      this.handleClose()
    },
    updateDetails () {
      this.$emit('updateAssetTransferDetails')
    },
    showDebitedAmountFlow () {
      this.handleClose()
      this.$emit('showDebitedAmount')
    }
  }
}
</script>

<style scoped>
.qr-code {
  box-shadow: 0px 2px 3px rgba(2, 1, 1, 0.09);
  border-radius: 11px;
}
.address {
  background: #f5f6fb;
  opacity: 0.66;
  border-radius: 0px 0px 9px 9px;
}
button {
  border-radius: 200px;
}
>>> .el-select {
  width: 100%;
}

>>> .el-input__prefix {
  left: 1px;
}
>>> .el-input__inner {
  font-size: 0.8rem;
  font-weight: 400;
}
>>> .hide-cancel-button .el-dialog__headerbtn {
  display: none !important;
}
@media screen and (min-width: 1280px) {
  >>> .el-dialog {
    margin-right: 29.5vw;
  }
}
@media screen and (min-width: 1680px) {
  >>> .el-dialog {
    margin-right: 31.5vw;
  }
}
</style>
